module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rodape clearfix"
  }, [_c('hr', {
    staticClass: "-full"
  }), _c('a', {
    staticClass: "back",
    on: {
      "click": _vm.historyBack
    }
  }, [_c('i', {
    staticClass: "fa fa-reply",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("   ")]), _vm._v("Voltar")]), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "share",
    attrs: {
      "href": "http://www.addthis.com/bookmark.php?v=300&pubid=ra-5a2eeaa74ba9d7fe",
      "target": "_blank",
      "noopener": "noopener"
    }
  }, [_vm._v("Compartilhar    "), _c('i', {
    staticClass: "zmdi zmdi-share",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-096debf7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/BackAndShare.vue
// module id = 451
// module chunks = 0